function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, "");
}

export function joinAssetUrl(baseUrl: string, assetPath: string): string {
  if (/^(?:https?:)?\/\//i.test(assetPath)) return assetPath;
  const path = assetPath.replace(/^\/+/, "");
  const base = trimTrailingSlash(baseUrl);
  return base ? `${base}/${path}` : `/${path}`;
}

const productionAssetBaseUrl = "https://storage.googleapis.com/023tlimages";
const productionDataApiBaseUrl = "https://storage.googleapis.com/storage/v1/b/023tlimages/o";
const productionImageApiBaseUrl = "https://storage.googleapis.com/download/storage/v1/b/023tlimages/o";
const configuredImageBaseUrl = trimTrailingSlash(import.meta.env.VITE_IMAGE_BASE_URL || "");

export function dataAssetUrl(assetPath: string): string {
  if (import.meta.env.DEV) return joinAssetUrl("/data", assetPath);
  const configuredBaseUrl = trimTrailingSlash(import.meta.env.VITE_DATA_BASE_URL || "");
  if (configuredBaseUrl) return joinAssetUrl(configuredBaseUrl, assetPath);
  const objectName = encodeURIComponent(`data/${assetPath.replace(/^\/+/, "")}`);
  return `${productionDataApiBaseUrl}/${objectName}?alt=media`;
}

export function corsImageAssetUrl(assetPath: string): string {
  if (/^(?:https?:)?\/\//i.test(assetPath) || import.meta.env.DEV || configuredImageBaseUrl) {
    return joinAssetUrl(appConfig.imageBaseUrl, assetPath);
  }
  const queryIndex = assetPath.indexOf("?");
  const objectPath = queryIndex < 0 ? assetPath : assetPath.slice(0, queryIndex);
  const query = queryIndex < 0 ? "" : assetPath.slice(queryIndex + 1);
  const objectName = encodeURIComponent(objectPath.replace(/^\/+/, ""));
  return `${productionImageApiBaseUrl}/${objectName}?alt=media${query ? `&${query}` : ""}`;
}

export const appConfig = {
  imageBaseUrl: trimTrailingSlash(import.meta.env.DEV
    ? ""
    : (configuredImageBaseUrl || productionAssetBaseUrl)),
  aipriDbApiUrl: import.meta.env.VITE_AIPRI_DB_API_URL
    || "https://script.google.com/macros/s/AKfycbz6-XulCnpCYFAXeJ0aJ6YDONY7UXTb9JelmC27N0OeuLgrpneruskNrqug7BloYy3n/exec",
};
